import axiosInstance from 'src/utils/axios';
import {
  CreateBusinessCustomerPayload,
  CustomerUsersResponse,
  GetBusinessCustomerListResponse,
  GetBusinessCustomerResponse,
} from './types.api';

//
//

const EXTEND_URL = '/customers/users/v1';
const BUSINESS_CUSTOMERS_URL = '/customers/business/v1';

//

export const getCustomerUsersAPI = async (
  email: string,
  includeLoginMethods?: boolean
): Promise<CustomerUsersResponse> => {
  const includeLoginMethodsParam =
    includeLoginMethods != null ? '&includeLoginMethods=' + !!includeLoginMethods : '';

  const encodedEmail = encodeURIComponent(email);

  const response = await axiosInstance.get<CustomerUsersResponse>(
    `${EXTEND_URL}?email=${encodedEmail}${includeLoginMethodsParam}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createMerchantCustomerAPI = async (data: any) => {
  return axiosInstance.post(`/customers/v1`, JSON.stringify(data));
};

export const updateUserAPI = async (email: string, updateLastSignedInAt: boolean) => {
  const encodedEmail = encodeURIComponent(email);
  return axiosInstance.patch(
    `${EXTEND_URL}?email=${encodedEmail}`,
    JSON.stringify({ updateLastSignedInAt })
  );
};

//
// business users

export const getBusinessCustomersListAPI = async ({
  merchantCode,
}: {
  merchantCode: string;
}): Promise<GetBusinessCustomerListResponse> => {
  const response = await axiosInstance.get<GetBusinessCustomerListResponse>(
    `${BUSINESS_CUSTOMERS_URL}?merchantCode=${merchantCode}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getBusinessCustomerByIdAPI = async ({
  id,
}: {
  id: string;
}): Promise<GetBusinessCustomerResponse> => {
  const response = await axiosInstance.get<GetBusinessCustomerResponse>(
    `${BUSINESS_CUSTOMERS_URL}/${id}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createBusinessCustomerAPI = async ({
  payload,
}: {
  payload: CreateBusinessCustomerPayload;
}) => {
  return axiosInstance.post(BUSINESS_CUSTOMERS_URL, JSON.stringify(payload));
};

export const editBusinessCustomerAPI = async ({
  id,
  payload,
}: {
  id: string;
  payload: CreateBusinessCustomerPayload;
}) => {
  return axiosInstance.patch(`${BUSINESS_CUSTOMERS_URL}/${id}`, JSON.stringify(payload));
};

export const deleteBusinessCustomerByIdAPI = async (id: string) => {
  return axiosInstance.delete(`${BUSINESS_CUSTOMERS_URL}/${id}`);
};
